import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            分区快速入口
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            四大核心分区精准导航，快速定位您感兴趣的精品内容领域
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat, idx) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="animate-fade-in-up group bg-background-100 hover:bg-background-200/70 rounded-lg p-6 transition-all duration-300 cursor-pointer"
              style={{ animationDelay: `${(idx + 1) * 0.1}s` }}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">
                {cat.name}
              </h3>
              <p className="text-foreground-600 text-xs leading-relaxed mb-4 line-clamp-2">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{cat.articleCount} 篇内容</span>
                <span className="text-primary-600 text-xs flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                  浏览 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}